import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import { useEffect, useState } from 'react';

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [requirePasswordChange, setRequirePasswordChange] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkPasswordChangeRequired = async () => {
      if (user) {
        const userDoc = doc(db, 'users', user.uid);
        const userSnap = await getDoc(userDoc);
        
        if (userSnap.exists()) {
          const userData = userSnap.data();
          setRequirePasswordChange(userData.firstLogin === true);
        }
      }
      setLoading(false);
    };

    checkPasswordChangeRequired();
  }, [user]);

  if (!user) {
    return <Navigate to="/login" replace />;
  }



  if (requirePasswordChange && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }

  return children;
}

export default ProtectedRoute;